import React from 'react';
import { AddressType } from './AddressField';
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';
import { FieldProps } from '../types';

const getDisplayedValue = (value?: string, hasComma = true) => (value ? `${hasComma ? ', ' : ''}${value}` : '');

const InlineAddressField = (props: FieldProps<AddressType>) => {
  const { getValue } = useFieldHelper(props);

  const address = getValue();
  let displayedValue = null;

  if (address) {
    const { country, state, city, addressLine1, addressLine2, zipCode } = address || {};

    displayedValue = [country, state, city, addressLine1, addressLine2, zipCode].reduce(
      (value, currentValue) => `${value}${getDisplayedValue(currentValue, !!value)}`,
      '',
    );
  }

  return <TextField value={displayedValue} />;
};

export default InlineAddressField;
